import { typedHttpsCallableWrapper } from '../api-_utils';
import { API_ROUTE_CONFIG } from './api-config/config';

export abstract class AssessmentAPI {
  public static create = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.assessment.crud.createAssessment
  );

  public static list = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.assessment.crud.listAssessments
  );
  public static cancel = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.assessment.crud.cancelAssessment
  );
  public static sendAssessmentEmail = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.assessment.crud.sendAssessmentEmail
  );

  /**
   * Start an assessment
   * @param patientId The ID of the current authenticated user is used. This field is not used
   * @param locationCode
   * @returns
   */
  public static start = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.assessment.crud.startAssessment
  );
}
